import React from 'react';
import { useFormState } from 'react-final-form';

import { MDText } from 'i18n-react';

import { DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS } from 'Utilities/analytics/analyticsDocumentCapture';

import ConfirmModal from '../../../../../components/ConfirmModal/ConfirmModal';
import { NotificationBanner } from '../../../../../components/notificationBanner/NotificationBanner';
import LocalTexts from '../../DocumentCapture.texts.json';
import { BeneficiaryValues } from '../AddBankDetails.types';

import styles from './AddBankDetailsModal.scss';

const LocalT = new MDText(LocalTexts.confirmModal);

type AddBankDetailsModalProps = {
  onCloseCallback: () => void;
  onSubmitCallback: (values: BeneficiaryValues) => Promise<void>;
}

export const AddBankDetailsModal = ({ onCloseCallback, onSubmitCallback }: AddBankDetailsModalProps) => {
  const { values } = useFormState();

  const onSubmitHandler = () => {
    DOCUMENT_CAPTURE_SNOW_PLOW_EVENTS.BANK_DETAILS_OVERLAY_CONTINUE();
    onSubmitCallback(values as BeneficiaryValues);

    // Close the modal as well incase Modulr responds with error
    onCloseCallback();
  };

  return (
    <ConfirmModal
      confirmText={`${LocalT.translate('confirm')}`}
      modalClassName={styles.confirmModal}
      onConfirm={onSubmitHandler}
      onReject={onCloseCallback}
      rejectText={`${LocalT.translate('reject')}`}
      shouldCloseOnOverlayClick={false}
    >
      <NotificationBanner
        label={LocalT.translate('label') as string}
        labelSize="large"
        message={LocalT.translate('message') as string}
      />
    </ConfirmModal>
  );
};
